<template>
    <el-container>
        <el-main style="padding:0px;">
            <router-view></router-view>
        </el-main>
    </el-container>
</template>

<script>
export default {
    name: 'Main',
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/views/wechat/components/main.vue